import type { CirclesChart } from '../circlesChart.js';
import type { CirclesVariant } from '../gameTypes.js';
import { PALETTE_CYAN } from '../builtinPulseMaps/palettes.js';
import { assembleImportedCirclesChart } from './importedOsuChart.js';
import audioOnsets from './audio/sky-high.onsets.json' with { type: 'json' };
import normalImported from './imported/sky-high-normal.circles.json' with { type: 'json' };
import hardImported from './imported/sky-high-hard.circles.json' with { type: 'json' };
import extremeImported from './imported/sky-high-extreme.circles.json' with { type: 'json' };

export const SKY_HIGH_CIRCLES_VARIANTS: Record<CirclesVariant, CirclesChart> = assembleImportedCirclesChart({
  baseSlug: 'sky-high',
  baseTitle: "Sky High",
  description: "Anthemic progressive house from Elektronomia. Four-on-the-floor groove with melodic leads.",
  difficulty: 2,
  palette: PALETTE_CYAN,
  audioSrc: '/audio/circles/sky-high.mp3',
  attribution: "\"Sky High\" by Elektronomia [NCS Release] - https://ncs.io/SkyHigh",
  mapper: "Facundo Yoel",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 118.72, offsetMs: 0, totalBeats: 121 },
    hard: { bpm: 118.72, offsetMs: 0, totalBeats: 121 },
    extreme: { bpm: 118.72, offsetMs: 0, totalBeats: 121 },
  },
});
